import 'primeicons/primeicons.css';
import './App.css';

import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Paths } from './components/Router/Paths';
import Router from './components/Router/Router';
import { useActiveTabSync } from './hooks/useActiveTabSync';
import { useBeforeUnload } from './hooks/useBeforeUnload';
import useScreenDimensions from './hooks/useScreenDimensions';
import authStore from './store/AuthStore';

const MIN_SCREEN_WIDTH = 720;

const App: FC = () => {
  const { screenWidth, screenHeight } = useScreenDimensions();

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    authStore.authenticate().catch(() => navigate(Paths.LOGIN));
  }, []);

  useActiveTabSync();
  useBeforeUnload();

  return screenWidth >= MIN_SCREEN_WIDTH ||
    location.pathname === Paths.MANAGE_ACCOUNTS ? (
    <Router />
  ) : (
    <div
      className="row align-items-center bold"
      style={{ height: screenHeight }}
    >
      <h3 className="text-center">
        {`Minimum supported screen width: ${MIN_SCREEN_WIDTH}px. Your screen width: ${screenWidth}px.`}
        <br />
        If you are using phone, try to rotate it.
      </h3>
    </div>
  );
};

export default App;
